/* NVZN3D TRUEVIEW AR JAVASCRIPT */

(function () {

  const nvznAppData = JSON.parse(document.getElementById('nvzn3d-trueview-data').textContent);
  if (!nvznAppData) return console.error('[NVZN] nvzn3d-trueview-data not found');
  log('nvzn3d-trueview-data:', nvznAppData);

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
      button.addEventListener('click', function () {
        const action = button.dataset.action;
        const selectedVariant = getSelectedVariant();
        if (!selectedVariant) return console.error('[NVZN] Unable to determine selected variant');
        log('Selected Variant:', selectedVariant);

        let options = {
          clientID: nvznAppData.app.clientID,
          width: selectedVariant.width,
          length: selectedVariant.length,
          units: selectedVariant.units,
          shape: selectedVariant.shape,
        };

        if (action === 'viewer') {
          options.imageUrl = selectedVariant.arImage;
          displayPreview(options);
        } else if (action === 'sizer') {
          displaySizer(options);
        }
      });
    });
    // detect option changes
    window.addEventListener('change', function (event) {
      updateButtonVisibility();
    });
    // update buttons
    updateButtonVisibility();
  }

  function displayPreview(options) {
    log('displayPreview', options);
    Nvzn3D.displayFloorPreview({
      clientId: options.clientID,
      width: options.width,
      length: options.length,
      units: options.units,
      imageUrl: options.imageUrl,
    });
  }

  function displaySizer(options) {
    log('displaySizer', options);
    Nvzn3D.displayFloorPreview({
      clientId: options.clientID,
      width: options.width,
      length: options.length,
      units: options.units,
      shape: options.shape,
    });
  }

  function getSelectedVariant() {
    if (!nvznAppData.product.variants || nvznAppData.product.variants.length === 0) {
      return nvznAppData.product;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant') || nvznAppData.product.selectedOrFirstAvailableVariantID.toString();
    const variant = nvznAppData.product.variants.find((v) => v.id.toString() === variantId);
    return variant || null;
  }

  function updateButtonVisibility() {
    const arViewerBtnContainer = document.querySelector('.nvzn3d-arbutton-container--viewer');
    if (!arViewerBtnContainer) return;
    // hide all
    arViewerBtnContainer.classList.remove('show');
    // determine selected item
    const selectedVariant = getSelectedVariant();
    if (!selectedVariant) return;
    // show viewer if arImage exists
    if (selectedVariant.arImage) {
      arViewerBtnContainer.classList.add('show');
    }
  }

  function log(...args) {
    if (nvznAppData.app && nvznAppData.app.logging) {
      console.log('[NVZN]', ...args);
    }
  }

  init();
})();